var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: { "no-margin-bottom": _vm.noMarginBottom },
          staticStyle: { "text-align": "initial !important" },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-input-group-append",
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      right: _vm.right,
                      "label-help": "",
                      "show-decade-nav": true,
                      "reset-button": _vm.resetButtton,
                      "label-reset-button": _vm.$t("reset"),
                      "label-current-month": _vm.$t("current-month"),
                      "label-next-year": _vm.$t("next-year"),
                      "label-selected": _vm.$t("selected-date"),
                      "label-next-month": _vm.$t("next-month"),
                      "label-prev-year": _vm.$t("prev-year"),
                      "label-prev-month": _vm.$t("prev-month"),
                      "label-next-decade": _vm.$t("next-decade"),
                      "label-prev-decade": _vm.$t("prev-decade"),
                      min: _vm.min
                        ? _vm.min
                        : _vm.dateAfterNow
                        ? new Date()
                        : null,
                      max: _vm.max
                        ? _vm.max
                        : _vm.dateBeforeNow
                        ? new Date()
                        : null,
                      "label-no-date-selected": _vm.placeholder,
                      "date-format-options": _vm.dateFormatOptions,
                      "start-weekday": _vm.MONDAY_START_ID,
                      locale: _vm.$i18nHelpers.getNormalizedLocale(),
                      placeholder: _vm.placeholder,
                      state: _vm.state
                    },
                    on: {
                      shown: function($event) {
                        return _vm.$emit("shown", $event)
                      },
                      hidden: function($event) {
                        return _vm.$emit("hidden", $event)
                      },
                      input: function($event) {
                        return _vm.$emit("input", $event)
                      }
                    },
                    model: {
                      value: _vm.localValue,
                      callback: function($$v) {
                        _vm.localValue = $$v
                      },
                      expression: "localValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("vuelidate-error", {
            attrs: {
              validator: _vm.validator,
              parentValidators: _vm.parentValidators,
              requiredErrorMsg: _vm.errorMsg,
              state: _vm.state
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364c408b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364c408b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseDatepicker.vue
// module id = 1634
// module chunks = 120